// import React, { useEffect } from "react";
// import { useArchiveForm } from "./contexts/ArchiveFormContext";
// import { useCategories } from "../../../lib/firebase/category/read";
// import { useAuthors } from "../../../lib/firebase/author/read";
// import { useSearchParams, Link } from "react-router-dom";
// import { Timestamp } from "firebase/firestore";
// import { Form, Button, Row, Col, Alert } from "react-bootstrap";
// import { formatMonthYear } from "../../../lib/utils/formatDate";

// function FormPage() {
//   const [searchParams] = useSearchParams();
//   const updateArchiveId = searchParams.get("id");
//   const updateMonthYear = searchParams.get("monthYear");

//   const {
//     data,
//     handleData,
//     documents,
//     handleDocumentChange,
//     addDocument,
//     removeDocument,
//     isUpdateLoading,
//     isDeleteLoading,
//     successMessage,
//     error,
//     // isDone,
//     handleCreate,
//     handleUpdate,
//     handleDelete,
//     fetchData,
//     isFetching,
//     resetForm,
//     validationErrors,
//   } = useArchiveForm();

//   const { data: categories } = useCategories();
//   const { data: authors } = useAuthors();

//   useEffect(() => {
//     if (!updateArchiveId && !updateMonthYear) {
//       resetForm();
//       handleData("productType", "Archive");
//     } else {
//       fetchData(updateArchiveId, updateMonthYear, "Archive");
//     }
//   }, [updateArchiveId, updateMonthYear, fetchData, resetForm, handleData]);

//   const formatDateForInput = (timestamp) => {
//     if (!timestamp) return "";
//     const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
//     return date.toISOString().split("T")[0];
//   };

//   const getCurrentDate = () => {
//     return new Date().toISOString().split("T")[0];
//   };

//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     const monthYear = formatMonthYear(data?.timestamp || Timestamp.now());
//     if (updateArchiveId && updateMonthYear) {
//       handleUpdate("Archive", monthYear);
//     } else {
//       handleCreate("Archive");
//     }
//   };

//   return (
//     <main className="py-2">
//       <div className="mb-3 d-flex justify-content-between align-items-center">
//         {updateArchiveId ? (
//           <span className="badge bg-warning text-dark">Update</span>
//         ) : (
//           <span className="badge bg-success text-white">Create</span>
//         )}
//         <h1 className="h4">Archives | Form</h1>
//         <Link to="/admin/archives" className="btn btn-secondary">
//           Back to Archives
//         </Link>
//       </div>

//       <section>
//         <Form
//           onSubmit={handleFormSubmit}
//           className="p-4 bg-light rounded shadow-sm"
//           noValidate
//         >
//           {/* Success/Error Messages */}
//           {successMessage && (
//             <Alert variant="success" className="text-center">
//               {successMessage}
//             </Alert>
//           )}
//           {error && (
//             <Alert variant="danger" className="text-center">
//               {error}
//             </Alert>
//           )}

//           {/* Archive-Level Fields */}
//           <div className="mb-4">
//             <h5>Archive Details</h5>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Published By <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={data?.publishedBy || ""}
//                     onChange={(e) => handleData("publishedBy", e.target.value)}
//                     required
//                     className={validationErrors.publishedBy ? "is-invalid" : ""}
//                   >
//                     <option value="">Select Publisher</option>
//                     {categories?.map((item) => (
//                       <option key={item?.id} value={item?.name}>
//                         {item?.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   {validationErrors.publishedBy && (
//                     <div className="invalid-feedback">
//                       {validationErrors.publishedBy}
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Category ID <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={data?.categoryId || ""}
//                     onChange={(e) => handleData("categoryId", e.target.value)}
//                     required
//                     className={validationErrors.categoryId ? "is-invalid" : ""}
//                   >
//                     <option value="">Select Category</option>
//                     {categories?.map((item) => (
//                       <option key={item?.id} value={item?.id}>
//                         {item?.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   {validationErrors.categoryId && (
//                     <div className="invalid-feedback">
//                       {validationErrors.categoryId}
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>
//             </Row>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Date <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="date"
//                     onChange={(e) => {
//                       const date = new Date(e.target.value);
//                       handleData("timestamp", Timestamp.fromDate(date));
//                     }}
//                     value={formatDateForInput(data?.timestamp)}
//                     max={getCurrentDate()}
//                     required
//                     className={validationErrors.timestamp ? "is-invalid" : ""}
//                   />
//                   {validationErrors.timestamp && (
//                     <div className="invalid-feedback">
//                       {validationErrors.timestamp}
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Meta Title <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     placeholder="Enter Meta Title"
//                     type="text"
//                     onChange={(e) => handleData("metaTitle", e.target.value)}
//                     value={data?.metaTitle || ""}
//                     required
//                     className={validationErrors.metaTitle ? "is-invalid" : ""}
//                   />
//                   {validationErrors.metaTitle && (
//                     <div className="invalid-feedback">
//                       {validationErrors.metaTitle}
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>
//             </Row>
//             <Row>
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Meta Description <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     placeholder="Enter Meta Description"
//                     type="text"
//                     onChange={(e) =>
//                       handleData("metaDescription", e.target.value)
//                     }
//                     value={data?.metaDescription || ""}
//                     required
//                     className={
//                       validationErrors.metaDescription ? "is-invalid" : ""
//                     }
//                   />
//                   {validationErrors.metaDescription && (
//                     <div className="invalid-feedback">
//                       {validationErrors.metaDescription}
//                     </div>
//                   )}
//                 </Form.Group>
//               </Col>
//             </Row>
//           </div>

//           {/* Documents Subcollection Fields */}
//           <div className="mb-4">
//             <h5>Documents</h5>
//             {documents.map((doc, index) => (
//               <div key={index} className="border p-3 mb-3 rounded">
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>
//                         Slug <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         placeholder="Enter Slug"
//                         type="text"
//                         value={doc.slug}
//                         onChange={(e) =>
//                           handleDocumentChange(index, "slug", e.target.value)
//                         }
//                         required
//                         disabled={updateArchiveId && doc.id}
//                         className={
//                           validationErrors.documents?.[index]?.slug
//                             ? "is-invalid"
//                             : ""
//                         }
//                       />
//                       {validationErrors.documents?.[index]?.slug && (
//                         <div className="invalid-feedback">
//                           {validationErrors.documents[index].slug}
//                         </div>
//                       )}
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>
//                         Article Title <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         placeholder="Enter Article Title"
//                         type="text"
//                         value={doc.title}
//                         onChange={(e) =>
//                           handleDocumentChange(index, "title", e.target.value)
//                         }
//                         required
//                         className={
//                           validationErrors.documents?.[index]?.title
//                             ? "is-invalid"
//                             : ""
//                         }
//                       />
//                       {validationErrors.documents?.[index]?.title && (
//                         <div className="invalid-feedback">
//                           {validationErrors.documents[index].title}
//                         </div>
//                       )}
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>
//                         Author Name <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={doc.author}
//                         onChange={(e) =>
//                           handleDocumentChange(index, "author", e.target.value)
//                         }
//                         required
//                         className={
//                           validationErrors.documents?.[index]?.author
//                             ? "is-invalid"
//                             : ""
//                         }
//                       >
//                         <option value="">Select Author</option>
//                         {authors?.map((author) => (
//                           <option key={author?.id} value={author?.name}>
//                             {author?.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                       {validationErrors.documents?.[index]?.author && (
//                         <div className="invalid-feedback">
//                           {validationErrors.documents[index].author}
//                         </div>
//                       )}
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label>
//                         Page No <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         placeholder="e.g., 1-5 or 06-08"
//                         type="text"
//                         value={doc.pageNo}
//                         onChange={(e) =>
//                           handleDocumentChange(index, "pageNo", e.target.value)
//                         }
//                         pattern="\d{1,2}-\d{1,2}"
//                         required
//                         className={
//                           validationErrors.documents?.[index]?.pageNo
//                             ? "is-invalid"
//                             : ""
//                         }
//                       />
//                       {validationErrors.documents?.[index]?.pageNo && (
//                         <div className="invalid-feedback">
//                           {validationErrors.documents[index].pageNo}
//                         </div>
//                       )}
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     PDF <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept="application/pdf"
//                     onChange={(e) =>
//                       handleDocumentChange(index, "pdfFile", e.target.files[0])
//                     }
//                     required={!doc.pdfUrl}
//                     className={
//                       validationErrors.documents?.[index]?.pdfFile
//                         ? "is-invalid"
//                         : ""
//                     }
//                   />
//                   {validationErrors.documents?.[index]?.pdfFile && (
//                     <div className="invalid-feedback">
//                       {validationErrors.documents[index].pdfFile}
//                     </div>
//                   )}
//                   {doc.pdfUrl && (
//                     <div className="mt-2">
//                       <a
//                         href={doc.pdfUrl}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         View Current PDF
//                       </a>
//                     </div>
//                   )}
//                 </Form.Group>
//                 {documents.length > 1 && (
//                   <Button
//                     variant="danger"
//                     size="sm"
//                     onClick={() => removeDocument(index)}
//                     className="mt-2"
//                   >
//                     Remove Document
//                   </Button>
//                 )}
//               </div>
//             ))}
//             <Button variant="secondary" onClick={addDocument} className="mb-3">
//               Add More Document
//             </Button>
//           </div>

//           <div className="d-flex gap-3">
//             <Button
//               type="submit"
//               disabled={isFetching || isUpdateLoading || isDeleteLoading}
//               variant="primary"
//               className="w-100"
//             >
//               {isUpdateLoading
//                 ? updateArchiveId
//                   ? "Updating..."
//                   : "Creating..."
//                 : updateArchiveId
//                 ? "Update"
//                 : "Create"}
//             </Button>
//             {updateArchiveId && updateMonthYear && (
//               <Button
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleDelete(updateArchiveId, updateMonthYear, "Archive");
//                 }}
//                 disabled={isFetching || isUpdateLoading || isDeleteLoading}
//                 variant="danger"
//                 className="w-100"
//               >
//                 {isDeleteLoading ? "Deleting..." : "Delete"}
//               </Button>
//             )}
//           </div>
//         </Form>
//       </section>
//     </main>
//   );
// }

// export default FormPage;

import React, { useEffect } from "react";
import { useArchiveForm } from "./contexts/ArchiveFormContext";
import { useCategories } from "../../../lib/firebase/category/read";
import { useAuthors } from "../../../lib/firebase/author/read";
import { useSearchParams, Link } from "react-router-dom";
import { Timestamp } from "firebase/firestore";
import { Form, Button, Row, Col, Alert } from "react-bootstrap";
import { formatMonthYear } from "../../../lib/utils/formatDate";

function FormPage() {
  const [searchParams] = useSearchParams();
  const updateArchiveId = searchParams.get("id");
  const updateMonthYear = searchParams.get("monthYear");

  const {
    data,
    handleData,
    documents,
    handleDocumentChange,
    addDocument,
    removeDocument,
    isUpdateLoading,
    isDeleteLoading,
    successMessage,
    error,
    // isDone,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    isFetching,
    resetForm,
    validationErrors,
  } = useArchiveForm();

  const { data: categories } = useCategories();
  const { data: authors } = useAuthors();

  useEffect(() => {
    if (!updateArchiveId && !updateMonthYear) {
      resetForm();
      handleData("productType", "Archive");
    } else {
      fetchData(updateArchiveId, updateMonthYear, "Archive");
    }
  }, [updateArchiveId, updateMonthYear, fetchData, resetForm, handleData]);

  const formatDateForInput = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toISOString().split("T")[0];
  };

  const getCurrentDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const monthYear = formatMonthYear(data?.timestamp || Timestamp.now());
    if (updateArchiveId && updateMonthYear) {
      handleUpdate("Archive", monthYear);
    } else {
      handleCreate("Archive");
    }
  };

  return (
    <main className="py-2">
      <div className="mb-3 d-flex justify-content-between align-items-center">
        {updateArchiveId ? (
          <span className="badge bg-warning text-dark">Update</span>
        ) : (
          <span className="badge bg-success text-white">Create</span>
        )}
        <h1 className="h4">Archives | Form</h1>
        <Link to="/admin/archives" className="btn btn-secondary">
          Back to Archives
        </Link>
      </div>

      <section>
        <Form
          onSubmit={handleFormSubmit}
          className="p-4 bg-light rounded shadow-sm"
          noValidate
        >
          {/* Success/Error Messages */}
          {successMessage && (
            <Alert variant="success" className="text-center">
              {successMessage}
            </Alert>
          )}
          {error && (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          )}

          {/* Archive-Level Fields */}
          <div className="mb-4">
            <h5>Archive Details</h5>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Published By <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={data?.publishedBy || ""}
                    onChange={(e) => handleData("publishedBy", e.target.value)}
                    required
                    className={validationErrors.publishedBy ? "is-invalid" : ""}
                  >
                    <option value="">Select Publisher</option>
                    {categories?.map((item) => (
                      <option key={item?.id} value={item?.name}>
                        {item?.name}
                      </option>
                    ))}
                  </Form.Select>
                  {validationErrors.publishedBy && (
                    <div className="invalid-feedback">
                      {validationErrors.publishedBy}
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Category ID <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    value={data?.categoryId || ""}
                    onChange={(e) => handleData("categoryId", e.target.value)}
                    required
                    className={validationErrors.categoryId ? "is-invalid" : ""}
                  >
                    <option value="">Select Category</option>
                    {categories?.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}
                      </option>
                    ))}
                  </Form.Select>
                  {validationErrors.categoryId && (
                    <div className="invalid-feedback">
                      {validationErrors.categoryId}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    onChange={(e) => {
                      const date = new Date(e.target.value);
                      handleData("timestamp", Timestamp.fromDate(date));
                    }}
                    value={formatDateForInput(data?.timestamp)}
                    max={getCurrentDate()}
                    required
                    className={validationErrors.timestamp ? "is-invalid" : ""}
                  />
                  {validationErrors.timestamp && (
                    <div className="invalid-feedback">
                      {validationErrors.timestamp}
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Meta Title <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder="Enter Meta Title"
                    type="text"
                    onChange={(e) => handleData("metaTitle", e.target.value)}
                    value={data?.metaTitle || ""}
                    required
                    className={validationErrors.metaTitle ? "is-invalid" : ""}
                  />
                  {validationErrors.metaTitle && (
                    <div className="invalid-feedback">
                      {validationErrors.metaTitle}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Meta Description <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder="Enter Meta Description"
                    type="text"
                    onChange={(e) =>
                      handleData("metaDescription", e.target.value)
                    }
                    value={data?.metaDescription || ""}
                    required
                    className={
                      validationErrors.metaDescription ? "is-invalid" : ""
                    }
                  />
                  {validationErrors.metaDescription && (
                    <div className="invalid-feedback">
                      {validationErrors.metaDescription}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Documents Subcollection Fields */}
          <div className="mb-4">
            <h5>Documents</h5>
            {documents.map((doc, index) => (
              <div key={index} className="border p-3 mb-3 rounded">
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Slug <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter Slug"
                        type="text"
                        value={doc.slug}
                        onChange={(e) =>
                          handleDocumentChange(index, "slug", e.target.value)
                        }
                        required
                        disabled={updateArchiveId && doc.id}
                        className={
                          validationErrors.documents?.[index]?.slug
                            ? "is-invalid"
                            : ""
                        }
                      />
                      {validationErrors.documents?.[index]?.slug && (
                        <div className="invalid-feedback">
                          {validationErrors.documents[index].slug}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Article Title <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter Article Title"
                        type="text"
                        value={doc.title}
                        onChange={(e) =>
                          handleDocumentChange(index, "title", e.target.value)
                        }
                        required
                        className={
                          validationErrors.documents?.[index]?.title
                            ? "is-invalid"
                            : ""
                        }
                      />
                      {validationErrors.documents?.[index]?.title && (
                        <div className="invalid-feedback">
                          {validationErrors.documents[index].title}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Author Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={doc.author}
                        onChange={(e) =>
                          handleDocumentChange(index, "author", e.target.value)
                        }
                        required
                        className={
                          validationErrors.documents?.[index]?.author
                            ? "is-invalid"
                            : ""
                        }
                      >
                        <option value="">Select Author</option>
                        {authors?.map((author) => (
                          <option key={author?.id} value={author?.name}>
                            {author?.name}
                          </option>
                        ))}
                      </Form.Select>
                      {validationErrors.documents?.[index]?.author && (
                        <div className="invalid-feedback">
                          {validationErrors.documents[index].author}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Page No <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        placeholder="e.g., 1-5 or 06-08"
                        type="text"
                        value={doc.pageNo}
                        onChange={(e) =>
                          handleDocumentChange(index, "pageNo", e.target.value)
                        }
                        pattern="\d{1,2}-\d{1,2}"
                        required
                        className={
                          validationErrors.documents?.[index]?.pageNo
                            ? "is-invalid"
                            : ""
                        }
                      />
                      {validationErrors.documents?.[index]?.pageNo && (
                        <div className="invalid-feedback">
                          {validationErrors.documents[index].pageNo}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3">
                  <Form.Label>
                    PDF <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    accept="application/pdf"
                    onChange={(e) =>
                      handleDocumentChange(index, "pdfFile", e.target.files[0])
                    }
                    required={!doc.pdfUrl}
                    className={
                      validationErrors.documents?.[index]?.pdfFile
                        ? "is-invalid"
                        : ""
                    }
                  />
                  {validationErrors.documents?.[index]?.pdfFile && (
                    <div className="invalid-feedback">
                      {validationErrors.documents[index].pdfFile}
                    </div>
                  )}
                  {doc.pdfUrl && (
                    <div className="mt-2">
                      <a
                        href={doc.pdfUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Current PDF
                      </a>
                    </div>
                  )}
                </Form.Group>
                {documents.length > 1 && (
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => removeDocument(index)}
                    className="mt-2"
                  >
                    Remove Document
                  </Button>
                )}
              </div>
            ))}
            <Button variant="secondary" onClick={addDocument} className="mb-3">
              Add More Document
            </Button>
          </div>

          <div className="d-flex gap-3">
            <Button
              type="submit"
              disabled={isFetching || isUpdateLoading || isDeleteLoading}
              variant="primary"
              className="w-100"
            >
              {isUpdateLoading
                ? updateArchiveId
                  ? "Updating..."
                  : "Creating..."
                : updateArchiveId
                ? "Update"
                : "Create"}
            </Button>
            {updateArchiveId && updateMonthYear && (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleDelete(updateArchiveId, updateMonthYear, "Archive");
                }}
                disabled={isFetching || isUpdateLoading || isDeleteLoading}
                variant="danger"
                className="w-100"
              >
                {isDeleteLoading ? "Deleting..." : "Delete"}
              </Button>
            )}
          </div>
        </Form>
      </section>
    </main>
  );
}

export default FormPage;
